import { render, staticRenderFns } from "./PoweredBy.vue?vue&type=template&id=70d837fc&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"
import style0 from "./PoweredBy.vue?vue&type=style&index=0&id=70d837fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d837fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d837fc')) {
      api.createRecord('70d837fc', component.options)
    } else {
      api.reload('70d837fc', component.options)
    }
    module.hot.accept("./PoweredBy.vue?vue&type=template&id=70d837fc&scoped=true", function () {
      api.rerender('70d837fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/PoweredBy/PoweredBy.vue"
export default component.exports